/**
 * Ling Database SDK - Frontend TypeScript SDK
 *
 * This module provides a comprehensive SDK for interacting with Ling's backend services.
 * It includes type definitions, service classes, error handling, and the main SDK client.
 */

// Type definitions for configuration and API responses
export type {
  Environment,
  LingDatabaseSDKConfig,
  OfflineConfig,
  OfflineStorageAdapter,
  NetworkStateDetector,
  ApiResponse,
  ApiSuccessResponse,
  ApiErrorResponse,
  VoiceSpeed,
  DaysOfWeek,
  WeekDaySelection,
  EquivalentUnitGroup,
} from "./types";

// Main SDK client class
export { LingDatabaseSDK } from "./core/client";

// Individual service classes for different backend modules
export { FavoritesService } from "./services/favorites-service";
export { ProfileService } from "./services/profile-service";
export { ProgressService } from "./services/progress-service";
export { SettingsService } from "./services/settings-service";
export { StreakService } from "./services/streak-service";
export { WebsocketService } from "./services/websocket-service";

// Error classes and utilities for comprehensive error handling
export {
  ErrorCodes,
  LingDatabaseError,
  AuthenticationError,
  ValidationError,
  NetworkError,
  ServiceError,
  isLingDatabaseError,
  createErrorFromResponse,
  handleHttpError,
} from "./errors";

// Storage adapters for React Native and other environments
export {
  createAsyncStorageAdapter,
  createMMKVStorageAdapter,
  createMemoryStorageAdapter,
} from "./utils/storage-adapters";

// Network detectors for different platforms
export {
  createWebNetworkDetector,
  createNetInfoDetector,
  createAlwaysOnlineDetector,
  createAlwaysOfflineDetector,
} from "./utils/network-detectors";
